import React from 'react';

const Segment = ({ data, activeSegment, handleSegmentHover }) => {

  return (
    <div
      className="segment"
      style={{
        width: data.durationFraction + "%",
        backgroundColor: data.colour,
      }}
      onMouseEnter={() => handleSegmentHover(data.id)}
      onMouseLeave={() => handleSegmentHover(null)}
    >
    </div>
  );
}

export default Segment;
